import templateUrl from 'emun.on-demand/shopping/shopping-clone-design-to-cart.htm'
import ShopController from 'emun.shopping/shop.controller'
import Design from 'emun.on-demand/lib/design'
import ProductListPicker from 'emun.products/lists/product-list-picker'

class AddDesignToCartController extends ShopController {
    constructor($cart) {
        super($cart)
    }
    $onInit() {
    }
    add(cartId) {
    }

    addToList() {
        ProductListPicker.open({ product: this.oneUp.product });
    }
    canLogin() {
    }
    canAdd() {
        return this.$session.isAuthenticated || this.$session.businessModel === 'Retail';
    }

    addCartItem() {
        let $ctrl = this;
        let designer = $ctrl.designer;
        let $cart = $ctrl.$cart;
        let item = $ctrl.oneUp.cartItem;
        let product = $ctrl.oneUp.product;

        let od = {
            fieldId: 'OnDemand',
            valueId: {}
        };

        ($ctrl.oneUp.product.areas || []).forEach(a => {
            if (a.copyFrom) return;
            od.valueId[a.euid] = {
                id: a.design.id,
                euid: a.design.euid,
                label: $ctrl.oneUp.product.shortDescription,
                width: a.width,
                height: a.height,
                background: a.backgroundColor,
                url: a.design.url,
                overlayIds: a.overlays.filter(o => o.isProductImage).map(o => o.euid),
                underlayIds: a.underlays.filter(o => o.isProductImage).map(o => o.euid)
            };
        });

        od.valueId = JSON.stringify(od.valueId);
        item.options = [od];

        if ($ctrl.oneUp.additionalOptions) {
            $ctrl.oneUp.additionalOptions.forEach(function (option) {
                var newOption = {
                    fieldId: option.id,
                    valueId: option.selectedOption,
                    fieldText: option.description
                };
                item.options.push(newOption);
            });
        }

        //console.debug('productOptions', JSON.stringify(productOptions));
        return $cart.addItem(item, product).then(() => {
            $cart.view();
        }, () => {
            //modals.alert('Please review the validation messages.', 'Could not add item to cart');
        });
    }
}

let AddDesignToCart = {
    require: {
        oneUp: '^shoppingOneUp'
    },
    controller: AddDesignToCartController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default AddDesignToCart;